var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTicketClassificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08333 0C0.934245 0 0 0.934245 0 2.08333V4.16667C0 4.45312 0.240885 4.67773 0.511068 4.77214C1.12305 4.98372 1.5625 5.56641 1.5625 6.25C1.5625 6.93359 1.12305 7.51628 0.511068 7.72786C0.240885 7.82227 0 8.04688 0 8.33333V10.4167C0 11.5658 0.934245 12.5 2.08333 12.5H16.6667C17.8158 12.5 18.75 11.5658 18.75 10.4167V8.33333C18.75 8.04688 18.5091 7.82227 18.2389 7.72786C17.627 7.51628 17.1875 6.93359 17.1875 6.25C17.1875 5.56641 17.627 4.98372 18.2389 4.77214C18.5091 4.67773 18.75 4.45312 18.75 4.16667V2.08333C18.75 0.934245 17.8158 0 16.6667 0H2.08333ZM4.16667 3.64583V8.85417C4.16667 9.14062 4.40104 9.375 4.6875 9.375H14.0625C14.349 9.375 14.5833 9.14062 14.5833 8.85417V3.64583C14.5833 3.35937 14.349 3.125 14.0625 3.125H4.6875C4.40104 3.125 4.16667 3.35937 4.16667 3.64583ZM3.125 3.125C3.125 2.54883 3.59049 2.08333 4.16667 2.08333H14.5833C15.1595 2.08333 15.625 2.54883 15.625 3.125V9.375C15.625 9.95117 15.1595 10.4167 14.5833 10.4167H4.16667C3.59049 10.4167 3.125 9.95117 3.125 9.375V3.125Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTicketClassificationIcon);
export default __webpack_public_path__ + "static/media/Filter-TicketClassification-Icon.69c2948d21afe0ce48a6eee6477d1351.svg";
export { ForwardRef as ReactComponent };